import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { moduleFragment } from '../model/module.fragments';
import { ModuleOutput } from '../model/module.output';

export interface FetchOrganizationModuleByIdParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class FetchOrganizationModuleByIdApiQuery extends ApiQuery<
	ModuleOutput,
	FetchOrganizationModuleByIdParams
> {
	client = 'content';
	document = gql`
		query FetchOrganizationModuleById($id: UUID!) {
			fetchOrganizationModuleById(id: $id) {
				...Module
			}
		}
		${moduleFragment}
	`;
	method = 'fetchOrganizationModuleById';
}
